import { Grid } from '@mui/material';
import { ReactComponent as KeyLinksIcon } from 'assets/wg-Key-link.svg';
import { ReactComponent as DerogationsIcon } from 'assets/wg-derogations-link.svg';
import { ReactComponent as SynergiCasesIcon } from 'assets/wg-synergi-cases-link.svg';
import { ReactComponent as WellHealthIcon } from 'assets/wg-well-health.svg';
import { ReactComponent as InterventionsIcon } from 'assets/wg-wir-well-select.svg';
import { ReactComponent as AlertManagementIcon } from 'assets/wg_alerts.svg';
import { PATHS } from 'constants/paths';
import { useIntl } from 'react-intl';
import { generatePath, NavLink } from 'react-router-dom';

import styles from './SidebarContentWellGuardian.module.scss';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch } from 'react-redux';
import { updateSideBarOpen } from '../../../../redux/WellGuardian';

interface SidebarContentWellGuardianProps {
  collapsed?: boolean;
  isOpen?: boolean;
  isLargeScreen?: boolean;
}

const SidebarContentWellGuardian: React.FunctionComponent<SidebarContentWellGuardianProps> = ({
  collapsed,
  isOpen,
  isLargeScreen: isLargeScreenProp,
}) => {
  const intl = useIntl();

  const isLargeScreen =
    typeof isLargeScreenProp === 'boolean'
      ? isLargeScreenProp
      : useMediaQuery('(min-width:1401px)');
  const dispatch = useDispatch();

  const handleNavClick = () => {
    if (!isLargeScreen && isOpen) {
      dispatch(updateSideBarOpen(false));
    }
  };

  return (
    <Grid direction="column" className={styles.linksContainer} container>
      <Grid direction="row">
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_WELL_HEALTH_HOME)}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.activeLink}` : styles.link
          }
          onClick={handleNavClick}
        >
          <Grid className={styles.linkContent} container>
            <WellHealthIcon />
            <Grid direction="row" className={collapsed ? styles.linkLabelHidden : styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.wellHealth' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid direction="row">
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_INTERVENTIONS)}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.activeLink}` : styles.link
          }
          onClick={handleNavClick}
        >
          <Grid className={styles.linkContent} container>
            <InterventionsIcon />
            <Grid direction="row" className={collapsed ? styles.linkLabelHidden : styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.interventions' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid direction="row">
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_DEROGATIONS)}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.activeLink}` : styles.link
          }
          onClick={handleNavClick}
        >
          <Grid className={styles.linkContent} container>
            <DerogationsIcon />
            <Grid direction="row" className={collapsed ? styles.linkLabelHidden : styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.derogations' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid direction="row">
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_SYNERGI_CASES)}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.activeLink}` : styles.link
          }
          onClick={handleNavClick}
        >
          <Grid className={styles.linkContent} container>
            <SynergiCasesIcon />
            <Grid direction="row" className={collapsed ? styles.linkLabelHidden : styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.synergiCases' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid direction="row">
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_KEY_LINK)}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.activeLink}` : styles.link
          }
          onClick={handleNavClick}
        >
          <Grid className={styles.linkContent} container>
            <KeyLinksIcon />
            <Grid direction="row" className={collapsed ? styles.linkLabelHidden : styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.KeyLinks' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid direction="row">
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_ALERTS_SUBSCRIPTION)}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.activeLink}` : styles.link
          }
          onClick={handleNavClick}
        >
          <Grid className={styles.linkContent} container>
            <AlertManagementIcon />
            <Grid direction="row" className={collapsed ? styles.linkLabelHidden : styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.alertManagement' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
    </Grid>
  );
};

export default SidebarContentWellGuardian;
